import React from 'react';

interface IRightSectionProps {
    children?: React.ReactNode;
}

const RightSection: React.FC<IRightSectionProps> = ({ children }) => (
    <div className="content-page__side content-page__side--right">{children}</div>
);

export default RightSection;
